// extracted by mini-css-extract-plugin
module.exports = {"close":"CloseModal_close__PjocY","bar":"CloseModal_bar__mqGZL","float":"CloseModal_float__RYepj","margin":"CloseModal_margin__42ckQ"};